
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Media', function () {

		// ==================================================
		// Load object schema
		// ==================================================
		let Media = Parse.Object.extend('Media');
		
	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/media.service.js